<script setup lang="ts">
import { AccordionRoot } from 'reka-ui';

const PartialsAccordionContentItem = resolveComponent('LazyPartialsAccordionContentItem');
const PartialsAccordionContentCategory = resolveComponent('LazyPartialsAccordionContentCategory');

function getAccordionComponent(alias: string) {
  switch (alias) {
    case 'accordionItem':
      return PartialsAccordionContentItem;
    case 'accordionCategory':
      return PartialsAccordionContentCategory;
    default:
      break;
  }
}

withDefaults(
  defineProps<{
    accordionItems: AccordionItemVariant[];
    allowMultiple?: boolean;
  }>(),
  {
    allowMultiple: false,
  },
);
</script>

<template>
  <AccordionRoot
    v-if="Array.isArray(accordionItems) && accordionItems.length > 0"
    :type="allowMultiple ? 'multiple' : 'single'"
    :collapsible="true"
    class="grid gap-4"
  >
    <template
      v-for="(item, index) in accordionItems"
      :key="index"
    >
      <PartialsAccordionItem
        v-if="item.content.title"
        :title="item.content.title"
        :accordion-item-index="index"
      >
        <component
          :is="getAccordionComponent(item.alias)"
          v-if="getAccordionComponent(item.alias)"
          :accordion-item="item"
        />
      </PartialsAccordionItem>
    </template>
  </AccordionRoot>
</template>
